import { Button, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material'
import { CurriculoContainer } from '../../components/CurriculoContainer'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGetEntrevistaByEmailQuery, usePostNewEntrevistaMutation, useDeleteEntrevistaMutation, useUpdateEntrevistaMutation } from 'shared/features/api/entrevista/entrevistaSlice'
import { useForm } from 'react-hook-form'
import { EntrevistaUpdateParams} from '../../shared/features/api/entrevista/types'
import { useGetLoggedUserQuery } from 'shared/features/api/usuario/authSlice'
import { toast } from 'react-toastify'
import { useGetCandidatoByEmailMutation } from 'shared/features/api/candidato/candidatoSlice'
import { Elemento } from 'shared/features/api/candidato/types'
import { useGetInscricaoByIdQuery } from 'shared/features/api/inscricao/inscricaoSlice'

export const InterviewCurriculum = () => {
  const { state } = useLocation()
  const {data: inscricao} = useGetInscricaoByIdQuery(state.id);
  const navigate = useNavigate()

  const [getCandidatosByEmail] = useGetCandidatoByEmailMutation()
  const [postNewEntrevista] = usePostNewEntrevistaMutation()
  const [deleteEntrevista] = useDeleteEntrevistaMutation()
  const [updateEntrevista] = useUpdateEntrevistaMutation()
  const [updateTrilha] = useUpdateFormMutation()
  const { isLoading } = useGetLoggedUserQuery()
  const { data, refetch } = useGetEntrevistaByEmailQuery(state?.email)

  const { register, handleSubmit } = useForm<EntrevistaUpdateParams>()
  const [inscricaoResponse, setInscricaoResponse] = useState<Elemento | null>(null)
  const [trilha, setTrilha] = useState<string>('')
  const [open, setOpen] = React.useState(false)
  const [openEditar, setOpenEditar] = React.useState(false)
  const [openCancelar, setOpenCancelar] = React.useState(false)

  const formValues = (data: string) => {
    return data === 'T' ? true : data === 'F' ? false : data
  }

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleClickOpenEditar = () => setOpenEditar(true)
  const handleCloseEditar = () => setOpenEditar(false)
  const handleClickOpenCancelar = () => setOpenCancelar(true)
  const handleCloseCancelar = () => setOpenCancelar(false)

  const getErrorMessage = (error: any, fallback: string) => {
    if (typeof error === "string" && error.trim()) {
      return error;
    }

    const apiMessage = error?.data?.message;
    if (typeof apiMessage === "string" && apiMessage.trim()) {
      return apiMessage;
    }

    const apiError = error?.data?.errors?.[0];
    if (typeof apiError === "string" && apiError.trim()) {
      return apiError;
    }

    if (typeof error?.error === "string" && error.error.trim()) {
      return error.error;
    }

    if (error instanceof Error && error.message.trim()) {
      return error.message;
    }

    return fallback;
  };

  function deletarEntrevista() {
    deleteEntrevista(state?.email)
      .unwrap()
      .then(() => {
        toast.success("Entrevista cancelada com sucesso!")
        refetch()
      })
      .catch((error: any) => {
        console.log(error)
        toast.error(getErrorMessage(error, "Erro ao cancelar entrevista."));
      })
      .finally(() => {
        handleCloseCancelar()
      })
  }

  const handleSubmitEntrevista = async (form: EntrevistaUpdateParams) => {
    isLoading === false &&
      postNewEntrevista({
        body: {
          candidatoEmail: state.email,
          dataEntrevista: form.body.dataEntrevista,
          avaliado: 'T',
          observacoes: form.body.observacoes
        }
      })
        .unwrap()
        .then(() => {
          toast.success('Entrevista agendada com sucesso!')
          refetch()

          inscricaoResponse &&
            updateTrilha({
              idInscricao: inscricaoResponse?.inscricao.idInscricao,
              inscricao: {
                matriculadoBoolean: formValues(
                  inscricaoResponse.inscricao.matriculado
                ),
                curso: inscricaoResponse.inscricao.curso,
                turno: inscricaoResponse?.inscricao.turno,
                instituicao: inscricaoResponse?.inscricao.instituicao,
                github: inscricaoResponse?.inscricao.github,
                linkedin: inscricaoResponse?.inscricao.linkedin,
                desafiosBoolean: formValues(
                  inscricaoResponse?.inscricao.desafios
                ),
                problemaBoolean: formValues(
                  inscricaoResponse?.inscricao.problema
                ),
                reconhecimentoBoolean: formValues(
                  inscricaoResponse?.inscricao.reconhecimento
                ),
                altruismoBoolean: formValues(
                  inscricaoResponse?.inscricao.altruismo
                ),
                resposta: inscricaoResponse?.inscricao.resposta,
                lgpdBoolean: formValues(inscricaoResponse?.inscricao.lgpd),
                provaBoolean: formValues(inscricaoResponse?.inscricao.prova),
                ingles: inscricaoResponse?.inscricao.ingles,
                espanhol: inscricaoResponse?.inscricao.espanhol,
                neurodiversidade:
                  inscricaoResponse?.neurodiversidade,
                efetivacaoBoolean: formValues(
                  inscricaoResponse?.inscricao.efetivacao
                ),
                disponibilidadeBoolean: formValues(
                  inscricaoResponse?.inscricao.disponibilidade
                ),
                genero: inscricaoResponse?.genero,
                trilhas: [inscricaoResponse?.inscricao.primeiraOpcaoTrilha, inscricaoResponse?.inscricao.segundaOpcaoTrilha],
                importancia: inscricaoResponse?.inscricao.importancia
              }
            })
              .unwrap()
              .catch((err: any) => {
                console.log(err)
              })
        })
        .catch((error: any) => {
          console.log(error)
          toast.error(getErrorMessage(error, "Erro ao agendar entrevista."));
        })
        .finally(() => {
          handleClose()
        })
  }

  const handleSubmitUpdateEntrevista = async (form: EntrevistaUpdateParams) => {
    isLoading === false &&
      updateEntrevista({
        idEntrevista: form.idEntrevista,
        legenda: "PENDENTE",
        body: {
          candidatoEmail: state.email,
          dataEntrevista: form.body.dataEntrevista,
          avaliado: 'T',
          observacoes: form.body.observacoes
        }
      })
        .unwrap()
        .then(() => {
          toast.success('Entrevista atualizada com sucesso!')
          refetch()
        })
        .catch((error: any) => {
          console.log(error)
          toast.error(getErrorMessage(error, "Erro ao atualizar entrevista."));
        })
        .finally(() => {
          handleCloseEditar()
        })
  }

  useEffect(() => {
    getCandidatosByEmail(state?.email)
      .unwrap()
      .then(res => {
        setInscricaoResponse(res)
      })
      .catch(e => console.log(e))
  }, [data])

  return (
    <Grid container spacing={2}>
      <>
        {data && (
          data?.candidatoDTO.notaEntrevistaComportamental > 0 ?
            (
              <Grid xs={12} item sx={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  id="interview-curriculum-agendar"
                  disabled
                >
                  Já entrevistado
                </Button>
              </Grid>
            ) :
            (
              <Grid xs={12} item sx={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  id="interview-curriculum-agendar"
                  onClick={handleClickOpenEditar}
                >
                  Editar agendamento
                </Button>
                <Button
                  variant="contained"
                  id="interview-curriculum-agendar"
                  onClick={handleClickOpenCancelar}
                >
                  Cancelar entrevista
                </Button>
                <Dialog open={openEditar} onClose={handleCloseEditar}>
                  <DialogTitle color="primary" sx={{ textAlign: "center" }}>Editar agendamento</DialogTitle>
                  <DialogContent>
                    <Stack
                      direction="column"
                      component="form"
                      onSubmit={handleSubmit(handleSubmitUpdateEntrevista)}
                      spacing={1}
                    >
                      <TextField
                        margin="dense"
                        autoFocus
                        type="datetime-local"
                        required={true}
                        InputLabelProps={{
                          shrink: true
                        }}
                        id="name"
                        label="Data e hora da entrevista"
                        defaultValue={data?.dataEntrevista}
                        {...register('body.dataEntrevista')}
                        fullWidth
                      />
                      <TextField
                        margin="dense"
                        id="name"
                        label="Observações"
                        defaultValue={data?.observacoes}
                        {...register('body.observacoes')}
                        multiline
                        rows={4}
                        fullWidth
                      />
                      <TextField
                        value={data?.idEntrevista}
                        {...register('idEntrevista')}
                        sx={{
                          display: "none"
                        }}
                      />
                      <Stack spacing={2} direction="row">
                        <Button
                          color="error"
                          sx={{ width: '100%' }}
                          onClick={handleCloseEditar}
                        >
                          Cancelar
                        </Button>
                        <Button sx={{ width: '100%' }} type="submit">
                          Salvar
                        </Button>
                      </Stack>
                    </Stack>
                  </DialogContent>
                </Dialog>
                <Dialog open={openCancelar} onClose={handleCloseCancelar}>
                  <DialogTitle color="secondary" sx={{ userSelect: "none", textAlign: "center", marginBottom: "12px" }}>Tem certeza?</DialogTitle>
                  <DialogContent>
                    <Stack
                      direction="column"
                      component="form"
                      spacing={1}
                    >
                      <Stack spacing={3} direction="column">
                        <Button variant='outlined' sx={{ width: '100%', fontWeight: 700 }} onClick={(() => deletarEntrevista())}>
                          Sim
                        </Button>
                        <Button
                          variant='outlined'
                          color="error"
                          sx={{ width: '100%', fontWeight: 700 }}
                          onClick={handleCloseCancelar}
                        >
                          Não
                        </Button>
                      </Stack>
                    </Stack>
                  </DialogContent>
                </Dialog>
              </Grid>
            )) || (
            <Grid xs={12} item>
              <Button
                variant="contained"
                id="interview-curriculum-agendar"
                onClick={handleClickOpen}
              >
                Agendar entrevista
              </Button>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle color="primary" sx={{ textAlign: "center" }}>Agendar entrevista</DialogTitle>
                <DialogContent>
                  <Stack
                    direction="column"
                    component="form"
                    onSubmit={handleSubmit(handleSubmitEntrevista)}
                    spacing={1}
                  >
                    <TextField
                      margin="dense"
                      autoFocus
                      type="datetime-local"
                      required={true}
                      InputLabelProps={{
                        shrink: true
                      }}
                      id="name"
                      label="Data e hora da entrevista"
                      {...register('body.dataEntrevista')}
                      fullWidth
                    />
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Trilha</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Trilha"
                        required={true}
                        value={trilha}
                        onChange={e => {
                          setTrilha(e.target.value)
                        }}
                      >
                          <MenuItem
                            key={inscricaoResponse?.inscricao.primeiraOpcaoTrilha}
                            value={inscricaoResponse?.inscricao.primeiraOpcaoTrilha}
                            id={`filtro-trilha-${inscricaoResponse?.inscricao.primeiraOpcaoTrilha}`}
                          >
                            {inscricaoResponse?.inscricao.primeiraOpcaoTrilha}
                          </MenuItem>
                        <MenuItem
                          key={inscricaoResponse?.inscricao.segundaOpcaoTrilha}
                          value={inscricaoResponse?.inscricao.segundaOpcaoTrilha}
                          id={`filtro-trilha-${inscricaoResponse?.inscricao.segundaOpcaoTrilha}`}
                        >
                          {inscricaoResponse?.inscricao.segundaOpcaoTrilha}
                        </MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      margin="dense"
                      id="name"
                      label="Observações"
                      {...register('body.observacoes')}
                      multiline
                      rows={4}
                      fullWidth
                    />
                    <Stack spacing={2} direction="row">
                      <Button
                        color="error"
                        sx={{ width: '100%' }}
                        onClick={handleClose}
                      >
                        Cancelar
                      </Button>
                      <Button sx={{ width: '100%' }} type="submit">
                        Agendar
                      </Button>
                    </Stack>
                  </Stack>
                </DialogContent>
              </Dialog>
            </Grid>
          )}
        <Grid item xs={12}>
        {inscricao && (
          <CurriculoContainer inscricao={inscricao} />  
        )}
        </Grid>
      </>
    </Grid >
  )
}
function useUpdateFormMutation(): [any] {
  throw new Error('Function not implemented.')
}

